import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  actions: {
    margin: '10px 0 20px 0',
    '& .MuiButton-root': {
      width: '100%'
    }
  }
});
export default useStyles;